export default "__VITE_ASSET__DA4FiTr3__"